import { render, staticRenderFns } from "./OrderStatusDetails.vue?vue&type=template&id=6a6394c5&scoped=true"
import script from "./OrderStatusDetails.vue?vue&type=script&lang=js"
export * from "./OrderStatusDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusDetails.vue?vue&type=style&index=0&id=6a6394c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6394c5",
  null
  
)

export default component.exports